import logo from './logo.svg';
import './App.css';
import {InputTag}from 'uipack-input-tag-component';

const getdata = (data) =>{
  console.log("mydata",data)
}

function App() {
  return (
    <div className="App">
   <InputTag data={getdata}></InputTag>
    </div>
  );
}

export default App;
